function compareObjectArray(array, valueToCompare) {
  return current =>
    array.filter(value => value[valueToCompare] === current[valueToCompare])
      .length === 0;
}

function sortArrayInAlphabeticalOrder(array, key = 'nome') {
  return array?.sort((a, b) => (a[key] > b[key] ? 1 : -1));
}

export { compareObjectArray, sortArrayInAlphabeticalOrder };
